var color = {
    color000: '#000000',
    color111: '#111111',
    color222: '#222222',
    color24: '#242424',
    color244: '#244E83',
    color25: '#252525',
    color2D7: '#2D7EE4',
    color2757: '#275794',
    color2ba: '#2ba7da',
    color333: '#333333',
    color418: '#418ded',
    color444: '#444444',
    color555: '#555555',
    color666: '#666666',
    color70: '#707070',
    color777: '#777777',
    color999: '#999999',
    colorAAA: '#AAAAAA',
    colorBBB: '#bbbbbb',
    colorCCC: '#cccccc',
    colorC5: '#c5c5c5',
    colorC7: '#c7c7c7',
    colorD3D2: '#d3d2d7',
    colorD3: '#d3d3d3',
    colorD5: '#d5d5d5',
    colorD6: '#d6d6d6',
    colorDBD: '#dbdce1',
    colorEAE: '#EAECED',
    colorEEE: '#eeeeee',
    colorEFE: '#EFEFEF',
    colorE1: '#e1e1e1',
    colorE2: '#e2e2e2',
    colorE5: '#e5e5e5',
    colorE50: '#e5001d',
    colorFA: '#fafafa',
    colorFFF: '#ffffff',
    colorF2: '#f2f2f2',
    colorF24: '#f2f2f4',
    colorF34: '#f34522',
    colorF4a: '#f4a100',
    colorF6: '#F6F6F6',
    colorF7: '#f7f7f7',
    colorF7F7FA: '#f7f7fa',
    colorF8: '#f8f8f8',
    colorF9: '#F9F9F9',
};
export default color;



//////////////////
// WEBPACK FOOTER
// ./src/detail/utils/color.ts
// module id = 4
// module chunks = 0